/**
 * Root application shell.
 * Wraps all routes in a BrowserRouter; delegates route definitions to AppContent.
 */
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import AppContent from "./AppContent";

const App = () => (
  <MotionConfig reducedMotion="user">
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  </MotionConfig>
);

export default App;
